/**
 * Input — text/email/number input matching the prototype's .input style.
 */
import type { InputHTMLAttributes } from 'react';
import './Input.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
  prefix?: string; // e.g. "£"
}

export function Input({ label, hint, error, prefix, className = '', id, ...rest }: InputProps) {
  const inputId = id ?? rest.name;
  const classes = ['itk-input', error ? 'itk-input--err' : '', className].filter(Boolean).join(' ');

  return (
    <div className="itk-field">
      {label && (
        <label className="itk-field__label" htmlFor={inputId}>
          {label}
        </label>
      )}
      {prefix ? (
        <div className="itk-input__prefix">
          <span className="itk-input__prefix-mark" aria-hidden="true">
            {prefix}
          </span>
          <input id={inputId} className={classes} {...rest} />
        </div>
      ) : (
        <input id={inputId} className={classes} {...rest} />
      )}
      {hint && !error && <p className="itk-field__hint">{hint}</p>}
      {error && (
        <p className="itk-field__err" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}